<template>
  <div
    v-if="visible"
    class="snackbar"
    :class="snackbarStore.snackbarType"
    data-test="snackbar"
  >
    {{ snackbarStore.message
    }}<X
      @click="
        () => {
          snackbarStore.hide();
        }
      "
      data-test="close-button"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useSnackbarStore } from '@/stores/SnackbarStore.js';
import X from '@/assets/XIcon.vue';

// Get the snackbar state from the store
const snackbarStore = useSnackbarStore();
const { visible, message, snackbarType } = storeToRefs(snackbarStore);
</script>

<style>
.snackbar {
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 16px;
  background-color: #333;
  color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  font-size: 0.8rem;
  font-weight: 500;
  width: 300px;
  height: 34px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.snackbar.info {
  background-color: #2196f3;
}
.snackbar.success {
  background-color: #4caf50;
}
.snackbar.warning {
  background-color: #ff9800;
}
.snackbar.error {
  background-color: #f44336;
}
</style>
